export default __webpack_public_path__ + "static/media/elevate-wht-poster-3.7c9e9e66.jpg";